import type { ToggleButtonProps } from "@mui/material";
import { ToggleButton as MuiToggleButton } from "@mui/material";
import type { FieldValues, Path } from "react-hook-form";
import { useController } from "react-hook-form";
import type { ElementTracking } from "../../../analytics/analytics";
import { useElementTracking } from "../../../analytics/analytics";

export const CeToggleButton = <TFieldValues extends FieldValues>({
  name,
  analyticsCategory,
  ...props
}: {
  name: Path<TFieldValues>;
} & ElementTracking &
  Omit<ToggleButtonProps, "value" | "onChange">): React.JSX.Element => {
  const { field } = useController<TFieldValues>({ name });
  const analyticsProps = useElementTracking(analyticsCategory, name, "toggle");
  return (
    <MuiToggleButton
      selected={!!field.value}
      name={field.name}
      value={field.value}
      onChange={() => {
        field.onChange(!field.value);
      }}
      {...analyticsProps}
      {...props}
    />
  );
};
